import { useState, useEffect } from "react";

export const useDynamicResolution = (breakpoint = 768): boolean => {
  const [isDesktop, setIsDesktop] = useState<boolean>(false);

  const comproveMedia = (event: MediaQueryListEvent): void => {
    if (event.matches) setIsDesktop(true);
    else setIsDesktop(false);
  };

  useEffect(() => {
    const desktopMediaQuery: MediaQueryList = window.matchMedia(
      `(min-width: ${breakpoint}px)`,
    );

    desktopMediaQuery.addEventListener("change", comproveMedia);

    if (desktopMediaQuery.matches) setIsDesktop(true);

    return () => {
      desktopMediaQuery.removeEventListener("change", comproveMedia);
    };
  }, [breakpoint]);

  return isDesktop;
};
